define('frontend-common-components/objectStorageConfig/js/views/items/base/baseItemView',[
    'marionette',
    'underscore',
    '../../../mixins/marionette/handleErrorDisplay'
], function (Marionette, _, handleErrorDisplay) {
    'use strict';
    return Marionette.ItemView.extend(_.extend(handleErrorDisplay));
});
